export default __webpack_public_path__ + "media/src/assets/images/ArrowDownIcon-9b5b776fa72d10241b9258be672b679a.svg";